import { useParams } from '@tanstack/react-router';

import { MemberDetailPage } from './MemberDetailPage';

export const CustomerMemberDetailPage = () => {
    const { userId, groupId } = useParams({ from: '/_app/customer-groups/$groupId/members/$userId' });
    return <MemberDetailPage userId={userId} groupId={groupId} />;
};
